var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-table",class:{
    'is-stripped':_vm.isStripped,
    'is-compact':_vm.isCompact,
    'hover-row':_vm.hoverRow,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }